import { h } from 'preact'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileImage = ({ image, alt, analytics, URL }) => {
   return (
      <a
         href={URL}
         class="tuile-image lien-composite"
         {...attributesAnalytics(analytics)}
      >
         <div class="image-container">
            <img class="bg-img" src={`${image}?saveas=webp`} alt="" />
            <img class="img" src={`${image}?saveas=webp`} alt={alt || ''} />
         </div>
      </a>
   )
}
